import React, { useEffect, useState } from "react";
import cls from "classnames";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { Button } from "../../Components/button";
import { withAuth, withTitle } from "../../HoC";
import { patchRequest, postRequest, deleteRequest } from "../../services/Requests";
import { translate } from "../../translations/translate";
import { actualPriorities } from "../../utils/constants";
import { Error, ErrorType } from "../../Components/Error";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
 } from "@material-ui/core";
import { DeleteForever } from "@material-ui/icons";

import { fetchData } from "./actions";

import { Header } from "../../Components/Header/Header";

import { Editor } from "./Editor";

import style from "./main.module.scss";
import useStyles from "./style";

const  dates = [
  "createdAt",
  "updatedAt",
];

const secrets = [
  "password",
];

const lists = [
  "priorities",
];

const transformValue = (key: any, value: any) => {

  if (dates.indexOf(key) >= 0)
    return new Date(value).toLocaleString();

  if (typeof value === "boolean") return value ? "true" : "false";

  if (typeof value === "number") return value;

  if (secrets.indexOf(key) >= 0) return "***";

  if (!value || typeof value === "undefined" || typeof value === null) return "N/A";

  if (lists.indexOf(key) >= 0) {
    return value
      .map((e, i) => e ? actualPriorities[i] : undefined)
      .filter(Boolean)
      .join(", ");
  }

  return value;
};

const extractKeys = (data) => Object.keys(data);

const CustomTable = ({
  data = [],
  mainTitle = "Table",
  onRowClick = (rowData: any, index: number) => {},
  onDelete,
}) => {
  const titles = data.length ? Object.keys(data[0]) : [];
  const keys = extractKeys(data[0] || {});
  return titles.length === 0 ? (
    <div className={cls(style["table-container"], { [style["empty"]]: titles.length === 0 })}>
      <h2> {mainTitle} </h2>
      <h3> No Records </h3>
    </div>
  ) : (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            {keys.map((key) => {
              return (<TableCell>{key}</TableCell>);
            })}
            <TableCell> Action </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row: any, index) => {
            return (<TableRow
              onClick={() => onRowClick(row, index)}
            >
              {Object.values(row).map((value: any, rowIndex: number) => {
                return (<TableCell> {value} </TableCell>);
              })}
              <TableCell>
              <IconButton onClick={(ev) => {
                ev.stopPropagation();
                onDelete(row.id);
              }} color="primary" aria-label="Delete Record" component="span">
                <DeleteForever />
              </IconButton>
              </TableCell>
            </TableRow>);
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

interface IEditor {
  isOpen: boolean;
  entity?: string;
  keyTitle?: string;
  newRecord?: boolean;
  data?: any;
}

export const Management = ({ actions, data }) => {

  const classes = useStyles();

  useEffect(() => {
    actions.fetchData();
  }, []);

  const deleteEntity = (entity: string) => async (id: string) => {
    await deleteRequest({ url: `management/${entity}/${id}` });
    await actions.fetchData();
  };

  const [ editorData, setEditor ] = useState<IEditor>({
    isOpen: false,
    entity: "",
    data: {},
    keyTitle: "",
    newRecord: false,
  });

  const [ errorMessage, setError ] = useState<any>({
    isVisible: false,
    title: "",
    message: "",
    type: ErrorType.Error,
  });

  const showMessage = (msg: any, time: number = 1500) => {
    setError({...msg, isVisible: true });
    setTimeout(() => {
      setError({ ...msg, isVisible: false });
    }, time);
  };

  const updateData = async (entity: string, newData: any) => {

    try {
      if (editorData.newRecord && entity === "users") {

        await postRequest({
          url: `management/${entity}`,
          body: newData,
        });
      } else {
        await patchRequest({
          url: `management/${entity}`,
          body: newData,
        });
      }

      actions.fetchData();
      setEditor({ isOpen: false, entity: "", data: {}, keyTitle: "", newRecord: false });
      showMessage({
        title: "Success",
        message: "your request was successful",
        type: ErrorType.Info,
      }, 1000);
    } catch (er) {
      showMessage({
        title: "Error!",
        message: "there was an error there",
        type: ErrorType.Error,
      }, 3000);
    }
  };

  return (<div className={style["wrapper"]}>
      <Header withProfile />
      <Card className={classes.card}>
        <CardHeader title="Users" />
        <CustomTable
          onRowClick={(rowData) =>
            setEditor({ isOpen: true, entity: "users", data: rowData, keyTitle: "name" })
          }
          mainTitle="Utenti"
          data={data.users}
          onDelete={deleteEntity("users")}
        />
        <div className={style["button-wrapper"]}>
          <Button
            label="Crea"
            onClick={() => setEditor({
              isOpen: true,
              entity: "users",
              keyTitle: "name",
              newRecord: true,
              data: data.users[0],
            })}
          />
        </div>
      </Card>
      <Card  className={classes.card}>
        <CardHeader title="Prenotazioni" />
        <CustomTable
          mainTitle="Prenotazioni"
          data={data.bookings}
          onRowClick={(rowData) =>
            setEditor({ isOpen: true, entity: "bookings", data: rowData, keyTitle: "Prenotazione" })
          }
          onDelete={deleteEntity("bookings")}
        />
        <div className={style["button-wrapper"]}>
          <Button
            label="Crea"
            onClick={() => setEditor({
              isOpen: true,
              entity: "bookings",
              data: data.bookings[0],
              keyTitle: "Prenotazione",
              newRecord: true,
            })}
          />
        </div>
      </Card>
      <Card  className={classes.card}>
        <CardHeader title="IoT Devices" />
        <CustomTable
          data={data.devices}
          onRowClick={(rowData) =>
            setEditor({ isOpen: true, entity: "devices", data: rowData, keyTitle: "description" })
          }
          onDelete={deleteEntity("devices")}
        />
        <div className={style["button-wrapper"]}>
          <Button
            label="Crea"
            onClick={() => setEditor({
              isOpen: true,
              entity: "devices",
              data: data.devices[0],
              keyTitle: "description",
              newRecord: true,
            })}
          />
        </div>
      </Card>
      <Card className={classes.card}>
        <CardHeader title="Punti Vendita" />
        <CustomTable
          mainTitle="Punti Vendita"
          data={data.stores}
          onRowClick={(rowData) =>
            setEditor({ isOpen: true, entity: "stores", data: rowData, keyTitle: "name" })
          }
          onDelete={deleteEntity("stores")}
        />
        <div className={style["button-wrapper"]}>
          <Button
            label="Crea"
            onClick={() => setEditor({
              isOpen: true,
              entity: "stores",
              data: data.stores[0],
              keyTitle: "",
              newRecord: true,
            })}
          />
        </div>
      </Card>

      <Dialog
        open={editorData.isOpen}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0,0,0,.8)",
          },
        }}
      >
        <DialogContent>
          <Editor
            data={editorData.data}
            entity={editorData.entity}
            keyTitle={editorData.keyTitle}
            newRecord={editorData.newRecord}
            onSave={updateData}
            onCancel={() => setEditor({ isOpen: false })}
          />
        </DialogContent>
      </Dialog>
    <Error {...errorMessage} />
  </div>);
};

const mapStateToProps = (state: any) => ({
  data: state.managementReducer.manageData,
});

const mapDispatchToProps = (dispatch) =>  ({
  actions : bindActionCreators({
    fetchData,
  }, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTitle("Management"),
  withAuth(10),
)(Management);
